import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather';
import Fragment from 'vue-fragment';
import * as VueGoogleMaps from 'vue2-google-maps'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import vuetify from './plugins/vuetify';
import store from './state';
import './registerServiceWorker';
import ImageUploader from 'vue-image-upload-resize';

// Views
const SignupView = () => import('@/views/SignUp.vue')
const SignUpFromEmail = () => import ('@/views/SignUpFromEmail');
const DriverSignup = () => import ('@/views/DriverSignup');
const LoginView = () => import ('@/views/LogIn.vue')
const TermsConditions = () => import('@/views/tc.vue');
const ForgotPasswordView = () => import('@/views/Forgot.vue')
const DashboardView = () => import('@/views/dashboard/Index.vue')
const DashboardCreateView = () => import('@/views/dashboard/Create.vue')

const AdminGraphView = () => import('@/views/dashboard/AdminGraph.vue')
const AdminScheduledBookings = () => import('@/components/bookings/admin/ScheduledBookings.vue')
const AdminBookingsView = () => import('@/views/dashboard/AdminBookings.vue')
const DriverBookingsView = () => import('@/views/dashboard/DriverBookings.vue')
const BookingsView = () => import('@/views/dashboard/Bookings.vue')
const DeliveryBookingsView = () => import('@/views/dashboard/AdminDeliveries.vue')
const ExchangeBookingsView = () => import('@/views/dashboard/AdminExchanges.vue')
const CollectionBookingsView = () => import('@/views/dashboard/AdminCollections.vue')
const AdminTruckBookingView = () => import('@/views/dashboard/AdminTruckBookings.vue')
const AdminDeletedBookingView = () => import('@/components/deletedBookings.vue')

const Profile = () => import('@/views/dashboard/Profile')
const WasteTypeView = () => import('@/views/dashboard/Waste-Type.vue')
const VehicleTypeView = () => import('@/views/dashboard/VehicleType.vue')
const DriverView = () => import('@/views/dashboard/Drivers.vue')

const AdminDisposalView = () => import('@/views/dashboard/AdminWasteDisposals.vue')
const DriverPastOrdersView = () => import('@/views/dashboard/DriverWasteDisposals.vue')
const DriverDisposalView = () => import('@/components/drivers/dashboard/DriverDisposals.vue')
const ClientBookingList = () => import('@/components/bookings/client/BookingTable.vue')
const trackBookings = () => import('@/components/bookings/client/clientMaps.vue')
const quoteBookings = () => import('@/components/bookings/client/Quotes.vue')
const ClientDisposalView = () => import('@/components/bookings/client/ClientDisposalTable.vue')

const UserView = () => import('@/views/dashboard/Users.vue')
const LogoutView = () => import('@/views/dashboard/Logout.vue')
const ServiceProviderAreaView = () => import('@/views/dashboard/ServiceProviderAreas.vue')

Vue.prototype.GOOGLE_MAPS_KEY = 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueFeather)
Vue.use(Fragment.Plugin)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo',
    libraries: 'places',
    installComponents: true
  }
})

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo'
});

Vue.use(ImageUploader);


export const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard/bookings'
    }, {
      path: '/signup',
      component: SignupView
    }, {
      path: '/driver-signup',
      component: DriverSignup
    }, {
      path: '/termsConditions',
      component: TermsConditions
    }, {
      path: '/login',
      component: LoginView,
      props: route => ({ emailAddress: route.query.emailAddress, password: route.query.password})
    }, {
      path: '/forgot',
      component: ForgotPasswordView
    }, {
      path: '/quote-redirect',
      component: SignUpFromEmail,
      props: route => ({ quoteId: route.query.quoteId, emailAddress: route.query.userEmail })
    }, {
      path: '/dashboard',
      redirect: '/dashboard/bookings',
      component: DashboardView,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'create',
          component: DashboardCreateView
        }, {
          path: 'truckbookings',
          component: AdminTruckBookingView,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'serviceProviderArea',
          component: ServiceProviderAreaView
        }, {
          path: 'wasteType',
          component: WasteTypeView
        }, {
          path: 'drivers',
          component: DriverView
        },{
          path: 'adminDisposals',
          component: AdminDisposalView
        },{
          path: 'driverDisposals',
          component: DriverDisposalView
        },{
          path: 'pastOrders',
          component: DriverPastOrdersView
        },{
          path: 'trackBookings',
          component: trackBookings
        },{
          path: 'bookingList',
          component: ClientBookingList
        },{
          path: 'BookingHistory',
          component: ClientDisposalView
        },{
          path: 'vehicleType',
          component: VehicleTypeView
        }, {
          path: 'Users',
          component: UserView
        }, {
          path: 'graph',
          component: AdminGraphView,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'driverBookings',
          component: DriverBookingsView,
        }, {
          path: 'adminBookings',
          component: AdminBookingsView,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'adminDeletedBookings',
          component: AdminDeletedBookingView,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'scheduledBookings',
          component: AdminScheduledBookings,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'bookings',
          component: BookingsView,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'quotes',
          component: quoteBookings,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'deliveryBookings',
          component: DeliveryBookingsView,
          meta: {
            requiresAuth: true
          }
        },{
          path: 'exchangeBookings',
          component: ExchangeBookingsView,
          meta: {
            requiresAuth: true
          }
        },{
          path: 'collectionBookings',
          component: CollectionBookingsView,
          meta: {
            requiresAuth: true
          }
        },{
          path: 'profile',
          component: Profile,
          meta: {
            requiresAuth: true
          }
        }, {
          path: 'logout',
          component: LogoutView
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  try {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const loggedInUser = store.getters['auth/isLoggedIn'];

    if (requiresAuth && !loggedInUser) {
      next('login');
    } else {
      next();
    }
  } catch (e) {
    console.log(e);
    alert(e.message);
    next('login');
  }
});

new Vue({
  render: h => h(App),
  vuetify,
  store,
  router
}).$mount('#app')
